/* eslint-disable react/jsx-no-bind */
import React from 'react';
import PropTypes from 'prop-types';
import Table from 'react-bootstrap/Table';
import dayjs from 'dayjs';

function ActionTable(props) {
  return (
    <Table responsive>
      <thead>
        <tr>
          <th className={'appt-th'}>Patient</th>
          <th className={'appt-th'}>Appt Date</th>
          <th className={'appt-th'}>Appt Created</th>
          <th className={'appt-th'}>Email/SMS</th>
          <th className={'appt-th'}>Login</th>
          <th className={'appt-th'}>Form Completion Rate</th>
          <th className={'appt-th'}>Call Log</th>
          <th className={'appt-th'}>Feedback</th>
        </tr>
      </thead>
      <tbody>
        {props.tableData.map((f, i) => (
          <tr key={f.apptId}>
            <td className={'appt-td'} onClick={() => props.patientClicked(f.patientId)}>
              {f.patientName}
            </td>
            <td className={'appt-td'} onClick={props.onAppointmentClick.bind(null, f.apptId)}>
              {dayjs(f.apptDueAt).format('MM/DD/YYYY')}
            </td>
            <td className={'appt-td'}>{dayjs(f.apptCreatedAt).format('MM/DD/YYYY')}</td>
            <td
              className={'appt-td'}
              onClick={props.onEmailClick.bind(null, {
                chrId: f.chrId,
                appointmentId: f.apptId,
              })}
            >
              {f.linkClicked ? <i className="fa fa-check" /> : <i className="fa fa-times" />}
            </td>
            <td
              className={'appt-td'}
              onClick={props.onLoginClick.bind(null, {
                chrId: f.chrId,
                appointmentId: f.apptId,
              })}
            >
              {f.loginSuccessful ? <i className="fa fa-check" /> : <i className="fa fa-times" />}
            </td>
            <td
              className={'appt-td'}
              onClick={props.onFormClick.bind(null, {
                chrId: f.chrId,
                appointmentId: f.apptId,
              })}
            >
              {f.formCompletionRate || 0}
            </td>
            <td className={'appt-td'}>{f.isCallCompleted ? <i className="fa fa-check" /> : <i className="fa fa-times" />}</td>
            <td className={'appt-td'}>{f.feedbackValue > 0 ? f.feedbackValue : 'NA'}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}
ActionTable.propTypes = {
  onEmailClick: PropTypes.func,
  onLoginClick: PropTypes.func,
  onFormClick: PropTypes.func,
  onAppointmentClick: PropTypes.func,
};

export default ActionTable;
